<template>
    <div>
        <div>
            <div class="lg:mt-[10em]" v-show="statusLoadingResultado != false">
                <LoadingLogo/>
            </div>
            <div>
                <NoResultLogo v-show="resultadosProfissional.Profissionais == null && resultadosPrestador.allResults == null && planoAtual.plano && statusLoadingResultado == false"/>
            </div>
            <div v-show="resultadosProfissional.Profissionais != null && statusLoadingResultado == false">
                <div class="lg:mt-10">
                    <div class="lg:w-[100%] h-[35rem] mx-auto w-[94%] mt-4 mb-4 max-lg:overflow-y-auto lg:overflow-x-auto rounded-md lg:grid lg:grid-cols-2">
                        <div v-for="(results, index) in resultadosProfissional.Profissionais" :key="index">
                            <div class="rounded-lg shadow-md mt-2 bg-white lg:w-[90%] max-lg:w-10/12 mx-auto">
                                <div class="p-6">
                                    <h5 class="text-gray-900 text-xl font-poppins font-semibold ">{{results.nome}}</h5>
                                    <p class="font-medium mb-2" style="color: #006e63; font-weight: 550;">MÉDICO</p>
                                    <div v-for="qualificacoes in results.qualificacoes" :key="qualificacoes.tipo_qualificacao.seq_qualificacao" class="p-2 inline-block">
                                        <img class="w-[30px] inline" :src="require(`../assets/${qualificacoes.tipo_qualificacao.seq_qualificacao}.png`)" :alt="`${qualificacoes.tipo_qualificacao.legenda_logo}`">
                                    </div>
                                </div>
                                <div class="p-2">
                                    <div class="mb-2">
                                        <svg class="w-6 mb-1 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
                                        <p class="text-base inline font-semibold">Local de Atendimento:</p>
                                    </div>
                                    <div v-if="results.local_atendimento" class="p-2 text-sm mt-[-20px]">
                                        <div class="p-3.5 max-lg:mt-6">
                                            <p class="relative antialiased text-base font-poppins font-medium top-[6px] mb-2"><span class="mr-1 font-bold">Nome Fantasia:</span>{{results.local_atendimento.nome_fantasia}}</p>
                                            <p class="font-poppins antialiased font-medium text-base mt-2"><span class="mr-1 font-bold">Razão Social:</span>{{results.local_atendimento.razao_social }}</p>
                                            
                                            <p v-if="results.local_atendimento.cnpj.length == 11" class="font-poppins antialiased font-medium text-base mt-1"><span class="mr-1 font-bold">CPF:</span>{{results.local_atendimento.cnpj | vueBrazil('cpf')}}</p>

                                            <p v-else class="font-poppins antialiased font-medium text-base mt-1"><span class="mr-1 font-bold">CNPJ:</span>{{results.local_atendimento.cnpj | vueBrazil('cnpj')}}</p>

                                           <p class="font-poppins antialiased font-medium text-base mt-1"><span class="mr-1 font-bold">Telefone:</span>{{results.local_atendimento.fone_coml | vueBrazil('telefone')}}</p>
<!--                                             <p v-for="telefones, telefonesIndex in result.telefones" :key="telefonesIndex" class="w-full font-poppins antialiased font-medium text-base mt-1" :href="'tel:' + telefones">{{telefones | vueBrazil('telefone')}}</p>
 -->                                            <p class="font-poppins antialiased font-medium text-base mt-2"><span class="mr-1 font-bold">Tipo de Especialidade:</span>{{results.local_atendimento.especialidade.nome }}</p>
                                        </div>
                                    </div> 
                                    <div v-if="statusComponent[index]"> 
                                        <MapsProfissional @close="showComponent(index, false)"/> 
                                    </div>
                                </div>
                                <div class="flex mr-4 mb-1 place-content-end"><img class="w-[35px]" src="@/assets/logoCortada.png" alt=""></div>
                                <div class="py-3 flex items-center justify-between font-medium px-4 border-t  border-gray-300 ">
                                    <div class="font-poppins font-semibold">
                                        {{results.conselho_profissional}} {{results.numero_conselho}}
                                    </div>
                                    <div class="flex flex-row">
                                        <button @click.prevent="getLocalSelecionado(index), showComponent(index, true) "  type="button" class="inline-block font-poppins px-3 py-2.5 bg-emerald-600 border-emerald-600 border text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-white hover:shadow-lg hover:text-emerald-700 hover:border-emerald-700 focus:bg-white focus:shadow-lg focus:outline-none focus:ring-0 active:bg-emerald-700 focus:text-emerald-700 active:text-emerald-700 active:shadow-lg transition duration-150 ease-in-out">
                                            Localização
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>  
                    </div>
                </div>
            </div>
        </div> 
    </div>
</template>

<script>
  import MapsProfissional from './mapsProfissional.vue';
  import { mapState } from 'vuex';
  import LoadingLogo from './loadingLogo.vue';
  import NoResultLogo from './noResultLogo.vue';

  export default{

    data(){
        return{
            statusComponent: {},
            statusPlanos: {},
        }
    },
    
    methods: {
        getLocalSelecionado(index) {
            this.$store.dispatch("loadLocalSelecionado", {
                local: this.$store.state.resultProfisional.Profissionais[index].local_atendimento
            });
        },

        showComponent(id, status){
            /* https://br.vuejs.org/v2/guide/reactivity.html */
            if (status) {
                this.$set(this.statusComponent, id, true);
            } else {
                this.statusComponent[id] = false;
            }
        },
    },


    computed: {
        resultadosProfissional() {
            return this.$store.state.resultProfisional;
        },

        resultadosPrestador() {
            return this.$store.state.resultPrestador;
        },

        ...mapState(['statusLoadingResultado', 'planoAtual'])
    },

    components: { MapsProfissional, LoadingLogo, NoResultLogo }
}
</script>
